import type { Dimension } from '../../shared/types.js';
import type { ListEntriesQuery } from '../../shared/schemas.js';
import { LEVELS, STATUSES } from '../../shared/levels.js';

interface Props {
  value: ListEntriesQuery;
  dimensions: Dimension[];
  onChange: (next: ListEntriesQuery) => void;
}

// Filter the list by dimension / level / project / status / date range.
export function Filters({ value, dimensions, onChange }: Props) {
  function set<K extends keyof ListEntriesQuery>(key: K, v: string) {
    const next = { ...value };
    if (v === '') delete next[key];
    else next[key] = v as ListEntriesQuery[K];
    onChange(next);
  }

  const active = Object.keys(value).length > 0;

  return (
    <div className="filters">
      <select value={value.dimension ?? ''} onChange={(e) => set('dimension', e.target.value)} aria-label="Filter by dimension">
        <option value="">All dimensions</option>
        {dimensions.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}
          </option>
        ))}
      </select>

      <select value={value.level ?? ''} onChange={(e) => set('level', e.target.value)} aria-label="Filter by level">
        <option value="">Any level</option>
        {LEVELS.map((l) => (
          <option key={l} value={l}>
            {l}
          </option>
        ))}
      </select>

      <select value={value.status ?? ''} onChange={(e) => set('status', e.target.value)} aria-label="Filter by status">
        <option value="">Any status</option>
        {STATUSES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Project"
        value={value.project ?? ''}
        onChange={(e) => set('project', e.target.value)}
        aria-label="Filter by project"
      />

      <label className="filter-date">
        From
        <input type="date" value={value.from ?? ''} onChange={(e) => set('from', e.target.value)} />
      </label>
      <label className="filter-date">
        To
        <input type="date" value={value.to ?? ''} onChange={(e) => set('to', e.target.value)} />
      </label>

      {active && (
        <button type="button" className="ghost" onClick={() => onChange({})}>
          Clear
        </button>
      )}
    </div>
  );
}
